"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safeComputeInteger = safeComputeInteger;
exports.tryCall = tryCall;
exports.getThreeDecimals = getThreeDecimals;
exports.now = now;
exports.currentRouteChannelEnabled = currentRouteChannelEnabled;
exports.getCurrentRouteChannelExtra = getCurrentRouteChannelExtra;
exports.transformToCamelCase = transformToCamelCase;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _lodash = _interopRequireDefault(require("lodash"));

var _constants = require("../constants");

var _path = require("./path");

var _compatibility = require("../compatibility");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function safeComputeInteger(func) {
  try {
    var value = Math.round(parseFloat(func()));
    return _lodash.default.isFinite(value) ? value : undefined;
  } catch (e) {
    return undefined;
  }
}

function tryCall(func) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  try {
    return func();
  } catch (e) {
    return defaultValue;
  }
}

function getThreeDecimals(_float) {
  try {
    var value = Math.round(_float * 1000) / 1000;
    return _lodash.default.isFinite(value) ? value : undefined;
  } catch (e) {
    return undefined;
  }
}

function now() {
  return (0, _compatibility.performanceNowAvailable)() ? performance.now() : Date.now();
}

function currentRouteChannelEnabled(channel) {
  var currentRoute = (0, _path.getRouteConfig)();
  return currentRoute[channel] && currentRoute[channel].enabled;
}

function getCurrentRouteChannelExtra(channel) {
  var currentRoute = (0, _path.getRouteConfig)();
  var defaultExtra = {
    businessType: _constants.UNKNOWN,
    businessChildType: _constants.UNKNOWN
  };
  return currentRoute[channel] ? currentRoute[channel].extraInfo || defaultExtra : defaultExtra;
}

function transformToCamelCase(obj) {
  if (!obj) {
    return {};
  }

  var r = {};
  Object.keys(obj).forEach(function (k) {
    var key = k.split('_').map(function (p, index) {
      if (index === 0) {
        return p;
      }

      return p.charAt(0).toUpperCase() + p.slice(1).toLowerCase();
    }).join("");
    r[key] = obj[k];
  });
  return r;
}